import DeliveryCalculator from './pages/DeliveryCalculator';
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import TwoFactor from './pages/TwoFactor';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import CustomerSelect from './pages/CustomerSelect';
import InvoiceView from './pages/InvoiceView';
import InvoiceSearch from './pages/InvoiceSearch';
import InvoiceEdit from './pages/InvoiceEdit';
import QuoteSearch from './pages/QuoteSearch';
import QuoteNew from './pages/QuoteNew';
import QuoteView from './pages/QuoteView';
import QuoteEdit from './pages/QuoteEdit';
import CustomerSettings from './pages/admin/CustomerSettings';
import ZoneRates from './pages/admin/ZoneRates';
import ZipData from './pages/admin/ZipData';
import CustomerManagement from './pages/admin/CustomerManagement';
import UserManagement from './pages/admin/UserManagement';
import SetupTwoFactor from './pages/SetupTwoFactor';
import ProSearch from './pages/ProSearch';
import CustomerCalculator from './pages/CustomerCalculator';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/invoices/new" element={<ProtectedRoute><DeliveryCalculator /></ProtectedRoute>} />
            <Route path="/invoices" element={<ProtectedRoute><InvoiceSearch /></ProtectedRoute>} />
            <Route path="/invoices/:id" element={<ProtectedRoute><InvoiceView /></ProtectedRoute>} />
            <Route path="/invoices/:id/edit" element={<ProtectedRoute><InvoiceEdit /></ProtectedRoute>} />
            <Route path="/pro-search" element={<ProtectedRoute><ProSearch /></ProtectedRoute>} />
            <Route path="/calculator" element={<ProtectedRoute><CustomerCalculator /></ProtectedRoute>} />
            <Route path="/admin/settings/:customerId" element={<ProtectedRoute requiredRole="boss"><CustomerSettings /></ProtectedRoute>} />
            <Route path="/admin/zone-rates/:customerId" element={<ProtectedRoute requiredRole="boss"><ZoneRates /></ProtectedRoute>} />
            <Route path="/admin/zip-data/:customerId" element={<ProtectedRoute requiredRole="boss"><ZipData /></ProtectedRoute>} />
            <Route path="/admin/customers" element={<ProtectedRoute requiredRole="admin"><CustomerManagement /></ProtectedRoute>} />
            <Route path="/admin/users" element={<ProtectedRoute requiredRole="admin"><UserManagement /></ProtectedRoute>} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/2fa" element={<TwoFactor />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/quotes/new" element={<ProtectedRoute><QuoteNew /></ProtectedRoute>} />
            <Route path="/quotes" element={<ProtectedRoute><QuoteSearch /></ProtectedRoute>} />
            <Route path="/quotes/:id" element={<ProtectedRoute><QuoteView /></ProtectedRoute>} />
            <Route path="/quotes/:id/edit" element={<ProtectedRoute><QuoteEdit /></ProtectedRoute>} />
            <Route path="/setup-2fa" element={
              <ProtectedRoute><SetupTwoFactor /></ProtectedRoute>
            } />
            <Route path="/select-customer" element={
              <ProtectedRoute><CustomerSelect /></ProtectedRoute>
            } />
            <Route path="/dashboard" element={
              <ProtectedRoute><Dashboard /></ProtectedRoute>
            } />
            <Route path="/" element={<Navigate to="/select-customer" replace />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
